/**
 * ------------------------------------------------------------
 * Developer Name : Praveen Tripathi
 * Purpose        : Hero banner accreditation / tag image chip
 * ------------------------------------------------------------
 */

import styles from "./ImageTag.module.scss";
import cn from "clsx";

const ImageTag = ({ htmlData = "", image = "" }) => {
  if (!htmlData && !image) return null;

  return (
    <div className={cn(styles.container, "mt-4")}>
      <img src={image} alt="Amity Online" title="Amity Online" />
      <div
        className={styles.imgTagTextContainer}
        dangerouslySetInnerHTML={{ __html: htmlData }}
      />
    </div>
  );
};

export default ImageTag;
